import cleanedFilename from '~/util/cleanedFilename';

export default {
  MENU_BUTTON: `${cleanedFilename(__filename)}-menu-button`,
  NAV_SETTINGS_DROPDOWN: `${cleanedFilename(__filename)}-nav-settings-dropdown`,
  SUBSCRIBE: 'subscribe',
  UNSUBSCRIBE: 'unsubscribe',
};
